<h4 class="config-tab-header"><i class="fal fa-cog me-2"></i>Platform Configuration</h4>

<adapt-display-accordion-hierarchy [hierarchyId]="personalHierarchyId"
                                   [hideRootWithoutChildren]="true"></adapt-display-accordion-hierarchy>
<adapt-display-accordion-hierarchy class="configuration-team-content"
                                   [hierarchyId]="teamHierarchyId"
                                   [hideRootWithoutChildren]="true"></adapt-display-accordion-hierarchy>
<adapt-display-accordion-hierarchy [hierarchyId]="organisationHierarchyId"
                                   [hideRootWithoutChildren]="true"></adapt-display-accordion-hierarchy>
